// StepOne.js
import React, { useEffect, useState } from "react";
import { Form, Button, Image, Icon } from "semantic-ui-react";
import { useFormik } from "formik";
import { initialValuesSix, validationSchemaSix } from "./StepSix.form";
import { SceneFormFile } from "./SceneFormFile";
import { VirtualScenes } from "../../../../api";
import { useAuth } from "../../../../hooks";
import "./SceneForm.scss";

const virtualSceneController = new VirtualScenes();

export function StepSix({
  formData,
  updateFormData,
  prevStep,
  isUpdateMode,
  scene,
  onReload,
  onClose,
}) {
  const { accessToken } = useAuth();
  const [isFileModalOpen, setIsFileModalOpen] = useState(false);
  const [isPublic, setIsPublic] = useState(true);
  const [fileFieldName, setFileFieldName] = useState("");
  const [moduleData, setModuleData] = useState(null);

  const [uploadedFileAdditionalMaterials, setUploadedFilesAdditionalMaterials] =
    useState({
      ModSixAdditionalMaterials: isUpdateMode
        ? moduleData?.ModSixAdditionalMaterials || [] // Espera un array, inicializa como vacío si no existe
        : formData.ModSixAdditionalMaterials || [],
    });

  const [uploadedFilesPdf, setUploadedFilesPdf] = useState({
    ModSixFilesPdf: isUpdateMode
      ? moduleData?.ModSixFilesPdf || [] // Inicializa como un array vacío si no hay datos
      : formData.ModSixFilesPdf || [],
  });

  const [uploadedFilerepository, setUploadedFilesrepository] = useState({
    ModSixRepository: isUpdateMode
      ? moduleData?.ModSixRepository || null
      : formData.ModSixRepository || null,
  });

  const [uploadedFilefooter, setUploadedfooter] = useState({
    ModSixFooter: isUpdateMode
      ? moduleData?.ModSixFooter || null
      : formData.ModSixFooter || null,
  });

  // Cargar datos del módulo en modo update
  useEffect(() => {
    async function fetchData() {
      if (isUpdateMode) {
        try {
          const data = await virtualSceneController.getVirtualScenesModeule(
            scene.refId,
            accessToken,
            "module_06",
          );
          setModuleData(data.moduleData);
          // console.log("module", data.moduleData);
        } catch (error) {
          console.error("Error fetching module data:", error);
        }
      }
    }
    fetchData();
  }, [isUpdateMode, accessToken, scene.refId]);

  // Manejo de subida de archivos
  const handleFileSubmit = (fileData) => {
    const { id } = fileData;

    switch (fileFieldName) {
      case "ModSixAdditionalMaterials":
        setUploadedFilesAdditionalMaterials((prev) => ({
          ...prev,
          [fileFieldName]: [...(prev[fileFieldName] || []), fileData],
        }));
        formik.setFieldValue(fileFieldName, [
          ...formik.values[fileFieldName],
          id,
        ]);
        break;
      case "ModSixFilesPdf":
        setUploadedFilesPdf((prev) => ({
          ...prev,
          [fileFieldName]: [...(prev[fileFieldName] || []), fileData],
        }));
        formik.setFieldValue(fileFieldName, [
          ...formik.values[fileFieldName],
          id,
        ]);
        break;
      case "ModSixRepository":
        setUploadedFilesrepository((prev) => ({
          ...prev,
          [fileFieldName]: fileData,
        }));
        formik.setFieldValue(fileFieldName, id);
        break;
      case "ModSixFooter":
        setUploadedfooter((prev) => ({
          ...prev,
          [fileFieldName]: fileData,
        }));
        formik.setFieldValue(fileFieldName, id);
        break;
      default:
        console.error(`Campo no reconocido: ${fileFieldName}`);
        break;
    }
  };

  // Manejo de borrado de archivos
  const handleRemoveFile = async (fieldName, index) => {
    let fileId;
    console.log("fieldName", fieldName);
    console.log("index", index);

    switch (fieldName) {
      case "ModSixAdditionalMaterials":
        if (
          uploadedFileAdditionalMaterials[fieldName] &&
          uploadedFileAdditionalMaterials[fieldName][index]
        ) {
          fileId = uploadedFileAdditionalMaterials[fieldName][index].id;
          try {
            await virtualSceneController.deleteImageRepo(accessToken, fileId);
            setUploadedFilesAdditionalMaterials((prev) => ({
              ...prev,
              [fieldName]: prev[fieldName].filter((_, i) => i !== index),
            }));
            formik.setFieldValue(
              fieldName,
              formik.values[fieldName].filter((_, i) => i !== index),
            );
          } catch (error) {
            console.error("Error al eliminar el archivo:", error);
          }
        }
        break;
      case "ModSixFilesPdf":
        if (uploadedFilesPdf[fieldName] && uploadedFilesPdf[fieldName][index]) {
          fileId = uploadedFilesPdf[fieldName][index].id;
          try {
            await virtualSceneController.deleteImageRepo(accessToken, fileId);
            setUploadedFilesPdf((prev) => ({
              ...prev,
              [fieldName]: prev[fieldName].filter((_, i) => i !== index),
            }));
            formik.setFieldValue(
              fieldName,
              formik.values[fieldName].filter((_, i) => i !== index),
            );
          } catch (error) {
            console.error("Error al eliminar el archivo:", error);
          }
        }
        break;
      case "ModSixRepository":
        if (uploadedFilerepository[fieldName]) {
          fileId = uploadedFilerepository[fieldName].id;
          try {
            await virtualSceneController.deleteImageRepo(accessToken, fileId);
            setUploadedFilesrepository((prev) => ({
              ...prev,
              [fieldName]: null,
            }));
            formik.setFieldValue(fieldName, null);
          } catch (error) {
            console.error("Error al eliminar el archivo:", error);
          }
        }
        break;
      case "ModSixFooter":
        if (uploadedFilefooter[fieldName]) {
          fileId = uploadedFilefooter[fieldName].id;
          try {
            await virtualSceneController.deleteImageRepo(accessToken, fileId);
            setUploadedfooter((prev) => ({
              ...prev,
              [fieldName]: null,
            }));
            formik.setFieldValue(fieldName, null);
          } catch (error) {
            console.error("Error al eliminar el archivo:", error);
          }
        }
        break;
      default:
        console.error("Campo no reconocido:", fieldName);
    }
  };

  const formik = useFormik({
    initialValues: isUpdateMode
      ? initialValuesSix(moduleData)
      : initialValuesSix(formData),
    validationSchema: validationSchemaSix(),
    validateOnChange: false,
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        console.log("values", values);
        let _id = "";
        if (isUpdateMode) {
          _id = scene.refId;
        } else {
          _id = localStorage.getItem("idScene");
        }

        // Manejo de tagsInput
        if (values.tagsInput) {
          values.tags = [...values.tags, values.tagsInput.trim()];
          values.tagsInput = "";
        }
        const modulePath = "module_06";
        const response = await virtualSceneController.createModuleAdd(
          modulePath,
          accessToken,
          _id,
          values,
        );
        console.log("response", response);
      } catch (error) {
        console.error("Error al enviar el formulario:", error);
      }

      updateFormData({
        ...values,
        ...uploadedFileAdditionalMaterials,
        ...uploadedFilesPdf,
        ...uploadedFilerepository,
        ...uploadedFilefooter,
      });
      onReload();
      if (onClose) {
        onClose(); // Cierra el modal
      }
    },
  });

  // Efecto para cargar archivos en update mode
  // Efecto para cargar archivos en update mode
  useEffect(() => {
    if (moduleData) {
      // CORRECCIÓN: El bloque formik.setValues({...}) se ha eliminado.
      // Es redundante y peligroso debido a que `enableReinitialize: true`
      // en la configuración de useFormik ya se encarga de esta tarea.

      // La lógica restante para buscar los archivos es correcta y necesaria.

      // Additional Materials
      if (
        moduleData.ModSixAdditionalMaterials &&
        Array.isArray(moduleData.ModSixAdditionalMaterials)
      ) {
        async function fetchFiles() {
          try {
            const filePromises = moduleData.ModSixAdditionalMaterials.map(
              (fileId) => virtualSceneController.getFileScene(fileId),
            );
            const fileDataArray = await Promise.all(filePromises);
            setUploadedFilesAdditionalMaterials((prev) => ({
              ...prev,
              ModSixAdditionalMaterials: fileDataArray,
            }));
          } catch (error) {
            console.error(
              "Error al obtener los datos de AdditionalMaterials:",
              error,
            );
          }
        }
        fetchFiles();
      }

      // PDFs
      if (
        moduleData.ModSixFilesPdf &&
        Array.isArray(moduleData.ModSixFilesPdf)
      ) {
        async function fetchFilespdf() {
          try {
            const filePromises = moduleData.ModSixFilesPdf.map((fileId) =>
              virtualSceneController.getFileScene(fileId),
            );
            const fileDataArray = await Promise.all(filePromises);
            setUploadedFilesPdf((prev) => ({
              ...prev,
              ModSixFilesPdf: fileDataArray,
            }));
          } catch (error) {
            console.error("Error al obtener los datos de FilesPdf:", error);
          }
        }
        fetchFilespdf();
      }

      // Repository
      if (moduleData.ModSixRepository) {
        async function fetchrepositoryFile() {
          try {
            const fileData = await virtualSceneController.getFileScene(
              moduleData.ModSixRepository,
            );
            setUploadedFilesrepository((prev) => ({
              ...prev,
              ModSixRepository: fileData,
            }));
          } catch (error) {
            console.error("Error al obtener los datos de repository:", error);
          }
        }
        fetchrepositoryFile();
      }

      // Footer
      if (moduleData.ModSixFooter) {
        async function fetchfooterFile() {
          try {
            const fileData = await virtualSceneController.getFileScene(
              moduleData.ModSixFooter,
            );
            setUploadedfooter((prev) => ({
              ...prev,
              ModSixFooter: fileData,
            }));
          } catch (error) {
            console.error("Error al obtener los datos de footer:", error);
          }
        }
        fetchfooterFile();
      }
    }
  }, [moduleData]);

  return (
    <Form className="virtual-scene-form" onSubmit={formik.handleSubmit}>
      {/* Imágenes Adicionales */}
      <div className="container">
        <Button
          type="button"
          onClick={() => {
            setIsPublic(true);
            setFileFieldName("ModSixAdditionalMaterials");
            setIsFileModalOpen(true);
          }}
        >
          Subir Imágenes Adicionales
        </Button>
        <div className="images-preview">
          {(
            uploadedFileAdditionalMaterials.ModSixAdditionalMaterials || []
          ).map((file, index) => (
            <div key={index} className="image-item">
              <Image src={file.url} size="small" />
              <Icon
                name="close"
                onClick={() =>
                  handleRemoveFile("ModSixAdditionalMaterials", index)
                }
              />
            </div>
          ))}
        </div>
      </div>

      {/* Fuentes */}
      <div className="container">
        <Form.TextArea
          name="ModSixFuentes"
          placeholder="fuentes del recurso"
          onChange={formik.handleChange}
          value={formik.values.ModSixFuentes}
          error={
            formik.errors.ModSixFuentes
              ? { content: formik.errors.ModSixFuentes }
              : null
          }
        />
      </div>

      {/* PDF Upload */}
      <div className="container">
        <Button
          type="button"
          onClick={() => {
            setIsPublic(false);
            setFileFieldName("ModSixFilesPdf");
            setIsFileModalOpen(true);
          }}
        >
          Subir PDFs
        </Button>
        <div className="container">
          {(uploadedFilesPdf.ModSixFilesPdf || []).map((file, index) => (
            <div key={index} className="file-item">
              <p>{file.title}</p>
              <Icon
                name="close"
                onClick={() => handleRemoveFile("ModSixFilesPdf", index)}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Repository */}
      <div className="container">
        <Button
          type="button"
          onClick={() => {
            setIsPublic(false);
            setFileFieldName("ModSixRepository");
            setIsFileModalOpen(true);
          }}
        >
          Subir Repositorio
        </Button>
        {uploadedFilerepository.ModSixRepository && (
          <div className="file-preview">
            <p>{uploadedFilerepository.ModSixRepository.title}</p>
            <Icon
              name="close"
              onClick={() => handleRemoveFile("ModSixRepository")}
            />
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="container">
        <Button
          type="button"
          onClick={() => {
            setIsPublic(true);
            setFileFieldName("ModSixFooter");
            setIsFileModalOpen(true);
          }}
        >
          Subir Imagen de cierre
        </Button>
        {uploadedFilefooter.ModSixFooter && (
          <div className="container">
            <Image
              src={uploadedFilefooter.ModSixFooter.url}
              size="small"
              centered
            />
            <Icon
              name="close"
              onClick={() => handleRemoveFile("ModSixFooter")}
            />
          </div>
        )}
      </div>

      {/* Modal for File Upload */}
      <SceneFormFile
        isOpen={isFileModalOpen}
        onClose={() => setIsFileModalOpen(false)}
        onSubmit={handleFileSubmit}
        isPublic={isPublic}
        idScene={formik.values.idScene}
      />
      <div className="formgroup">
        <Form.Group>
          <Button
            type="button"
            onClick={prevStep}
            color="orange"
            style={{ width: "33.3333%" }}
          >
            Anterior
          </Button>
          <Button
            type="submit"
            primary
            style={{ width: "66.6666%" }}
            loading={formik.isSubmitting}
            onClick={() => console.log(formik.values, isUpdateMode)}
          >
            Publicar y cerrar
          </Button>
        </Form.Group>
      </div>
    </Form>
  );
}
